export default __webpack_public_path__ + "static/media/tete19.1d701464.png";